var _circle, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#1DBF73"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1965_6197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 8,
    width: 22,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.65625,
    y: 8,
    width: 20.5292,
    height: 19.6875,
    fill: "url(#pattern0_1965_6197)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1965_6197)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.57,
    cy: 18.3826,
    rx: 24.5388,
    ry: 18.5339,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1965_6197",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1965_6197",
    transform: "matrix(0.0078125 0 0 0.0081465 0 -0.0213759)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1965_6197",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAN2AAADdgF91YLMAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAIFQTFRF////AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAga6qMgAAACp0Uk5TAAYHCAkTIDY8V1tcXV5fYGFkaGmHiImKi4yNjo+VmqCyuLvJ0trp8/z9Iz2yWgAAAYZJREFUeNrt2NlSwkAQheEWNVHcjQYXYtREJ/T7P6ClFlUGhiyzdBfmnPvh+68oaCIMwzAMw7BpLikqU5epmp8Z/l6TH+j4S14vV/a5SXV95lLZ51rZZyPtP7d9rpR9LpR9k+j6nCn7S/jwJ+M/wYcPH/5E/Uf48OHDn6j/AB8+fPh76B/fvrwXN0de/sLDP/38efBxouRn6yeraxU/Mexd4ONT8eeZY4GXTxX7Fvj5ZFpPV1fSPtXsV+DrU8leBd4+pY1PwSLA92+++RGrS/e3Lt//szfngiA+0aFrQSDfuSCY71gQ0LcWXEj6DgWB/dEFwf2RBRF8a8G5pD+i4D7W79+BBdH8gQURfWvBmaQ/oCCy31sQ3e8pEPA7C0R8a8Fc0rcVNHNJf0fBneT/f0vBq+z9YbtA+v7RWxD9/tJTIHD/6SwQuT91FAjdv3YWiN3fdhQI3v+sBaL3R0uB7P1zu0DY3yoQ9zcKFPxWgYpPNMt/70gmI62lZW2qIiEMwzAMw7D/uC9q22uDR+zMzgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.32ac287cae7502d958113cbf801eb906.svg";
export { ForwardRef as ReactComponent };